import { render, staticRenderFns } from "./StylistCustomers.vue?vue&type=template&id=5d5910d4&scoped=true&"
import script from "./StylistCustomers.vue?vue&type=script&lang=js&"
export * from "./StylistCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5910d4",
  null
  
)

export default component.exports